import { call, put, select } from 'redux-saga/effects';
import * as types from './user-group.types';
import * as actions from './user-group.actions';
import { userGroupSelectors } from './user-group.selectors';

import { apiRequest } from '../../api/api.saga-services';
import * as api from '../../api/request-config/user-group.api';
import { removeGroupFromUsers } from '../user/user.saga-service';

export function* storeUserGroup(userGroup: types.IUserGroup) {
  yield put(actions.storeUserGroup(userGroup));
  return userGroup;
}

export function* clearUserGroup(userGroupId: types.IUserGroup['id']) {
  // remove association from users
  yield call(removeGroupFromUsers, userGroupId);
  // now remove the group
  yield put(actions.clearUserGroup(userGroupId));
}
export function* clearAllUserGroups() {
  const userGroupIds: types.IUserGroup['id'][] = yield select(userGroupSelectors.selectResourceIds);
  yield put(actions.clearUserGroup(userGroupIds));
}

export function* getUserGroups() {
  const userGroupsData = (yield call(apiRequest, api.getUserGroupsApi())) as types.IUserGroupGet[];
  if (!userGroupsData) {
    return;
  }

  const userGroups = userGroupsData.map(({ changedAt, id, name, changedBy, users }) => {
    const userGroup: types.IUserGroup = {
      changedAt,
      id,
      changedBy,
      name,
      userIds: users.filter((user) => !user.deleted).map((user) => user.id),
    };
    return userGroup;
  });
  yield put(actions.storeUserGroup(userGroups));
  return userGroups;
}

export function* createUserGroup(data: types.IUserGroupCreate) {
  const userGroup = (yield call(apiRequest, api.createUserGroupApi(data))) as types.IUserGroup;
  if (!userGroup) {
    return;
  }
  // default to an empty users ID array
  userGroup.userIds = [];
  yield call(storeUserGroup, userGroup);
  return userGroup.id;
}

export function* updateUserGroup(id: types.IUserGroup['id'], name: types.IUserGroupUpdate['name']) {
  const updateUserGroup = (yield call(apiRequest, api.updateUserGroupApi(id, name))) as types.IUserGroup;
  if (!updateUserGroup) {
    return;
  }
  yield call(storeUserGroup, updateUserGroup);
  return updateUserGroup.id;
}

export function* deleteUserGroup(id: types.IUserGroup['id']) {
  yield call(apiRequest, api.deleteUserGroupApi(id));
  // remove the group from the store
  yield call(clearUserGroup, id);
}
